// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/
// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.
// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx
import baseIcon from '@bubble-ui/temp-icon-base';
var IconClosePath = 'M10.872 10.004c.449-.14.875-.373 1.23-.729l5.602-5.601L16.29 2.26l-5.602 5.601a.999.999 0 01-1.414 0l-5.57-5.57L2.29 3.705l5.57 5.57c.364.364.8.6 1.261.738a2.86 2.86 0 00-1.229.708L2.29 16.322l1.414 1.414 5.603-5.601a1.022 1.022 0 011.413 0l5.57 5.57 1.414-1.414-5.57-5.57a2.869 2.869 0 00-1.262-.717z';
var IconClose = baseIcon('IconClose', {
  getPath: function getPath() {
    return IconClosePath;
  }
});
export default IconClose;
//# sourceMappingURL=index.js.map